<template>
    <div id="new-netgsm-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>Kanal Adı</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            placeholder="Kanal Adı"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>Domain *</label>
                    <a-input
                        v-model="form.domain"
                        v-validate="'required'"
                        name="domain"
                        placeholder="Örn: sip11.netsantral.com"
                    />
                </div>
                <div class="input-wrapper">
                    <label>WebSocket Server *</label>
                    <a-input
                        placeholder="Örn: wss://sip11.netsantral.com:8089/ws"
                        v-model="form.websocketServer"
                        v-validate="'required'"
                        name="websocketServer"
                    />
                </div>
                <div class="input-wrapper">
                    <label>Telefon Numarası *</label>
                    <a-input
                        placeholder="Örn: 8502592789 (Başında 0 olmadan)"
                        v-model="form.phoneNumber"
                        v-validate="'required'"
                        name="phoneNumber"
                    />
                    <small class="help-text">PBX'deki numaranızı başında 0 olmadan girin</small>
                </div>
                <div class="input-wrapper">
                    <label>API Şifresi *</label>
                    <a-input
                        placeholder="API kullanıcı şifrenizi girin"
                        v-model="form.passwordForApi"
                        v-validate="'required'"
                        name="passwordForApi"
                        type="password"
                    />
                    <small class="help-text">
                        <a href="https://portal.netgsm.com.tr/webportal/abonelikislemleri/apitalep/" target="_blank">
                            Buradan API şifrenizi alabilirsiniz
                        </a>
                    </small>
                </div>
                <div class="input-wrapper">
                    <label>Portal Şifresi *</label>
                    <a-input
                        placeholder="Portal giriş şifrenizi girin"
                        v-model="form.passwordForPortal"
                        v-validate="'required'"
                        name="passwordForPortal"
                        type="password"
                    />
                    <small class="help-text">NetGSM portal'a giriş şifreniz (API şifresinden farklıdır)</small>
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">İptal</a-button>
                <a-button class="pr-confirm-btn" @click="handleSubmit" type="primary" :disabled="loading">
                    Bağlan
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "CreateNetGsmChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    components: {},
    data() {
        return {
            form: {
                channelName: "NetGSM",
                domain: "",
                websocketServer: "",
                phoneNumber: "",
                passwordForApi: "",
                passwordForPortal: "",
            },
            loading: false,
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "Bu alan zorunludur" : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        async completeCreateChannel(payload) {
            const data = {
                payload,
                type: "webphone-netgsm",
                name: this.form.channelName || "NetGSM",
            };
            return this.createChannel(data)
                .then(() => {
                    this.$message.success("Kanal başarıyla oluşturuldu");
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error("Kanal oluşturulurken bir hata oluştu");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            
            // Validate required fields
            if (!this.form.domain || !this.form.websocketServer || !this.form.phoneNumber || 
                !this.form.passwordForApi || !this.form.passwordForPortal) {
                this.$message.error("Tüm zorunlu alanları doldurun");
                return;
            }

            // Telefon numarası validasyonu
            if (this.form.phoneNumber.startsWith("0")) {
                this.$message.error("Telefon numarası 0 ile başlamamalıdır");
                return;
            }

            // WebSocket URL validasyonu
            if (!this.form.websocketServer.match(/^wss?:\/\/.+/)) {
                this.$message.error("WebSocket Server geçerli bir URL olmalıdır");
                return;
            }

            const isValid = true;
            if (isValid) {
                this.loading = true;
                const payload = {
                    domain: this.form.domain,
                    websocketServer: this.form.websocketServer,
                    phoneNumber: this.form.phoneNumber,
                    passwordForApi: this.form.passwordForApi,
                    passwordForPortal: this.form.passwordForPortal,
                    apiAddressV1: "https://app.netgsm.com.tr/santralapi/v1",
                    apiAddressV2: "https://api.netgsm.com.tr/netsantral",
                };
                this.completeCreateChannel(payload);
            }
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-netgsm-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            min-height: 75px;

            label {
                font-weight: 500;
                margin-bottom: 5px;
            }

            .help-text {
                color: #666;
                font-size: 12px;
                margin-top: 4px;

                a {
                    color: #1890ff;
                    text-decoration: none;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>
